import { createRouter, createWebHistory } from 'vue-router'
import { adminSections, clientSections } from './sections.js'

const PortalPage = () => import('../pages/PortalPage.vue')
const NotFoundPage = () => import('../pages/NotFoundPage.vue')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'storefront', component: PortalPage, meta: { portal: 'index', title: 'Voucher Internet' } },
    { path: '/terms', alias: ['/syarat-ketentuan', '/syarat-ketentuan.html'], name: 'terms', component: PortalPage, meta: { portal: 'terms', title: 'Syarat & Ketentuan' } },
    { path: '/maintenance', alias: ['/maintenance.html'], name: 'maintenance', component: PortalPage, meta: { portal: 'maintenance', title: 'Pemeliharaan Sistem' } },
    {
      path: '/client/:section?',
      alias: ['/client.html'],
      name: 'client',
      component: PortalPage,
      meta: { portal: 'client', title: 'Portal Pelanggan' },
      beforeEnter: (to) => {
        const section = to.params.section
        if (section && !clientSections.includes(section)) return { name: 'client', params: { section: 'dashboard' } }
      }
    },
    {
      path: '/admin/:section?',
      alias: ['/admin.html'],
      name: 'admin',
      component: PortalPage,
      meta: { portal: 'admin', title: 'Admin Panel' },
      beforeEnter: (to) => {
        const section = to.params.section
        if (section && !adminSections.includes(section)) return { name: 'admin', params: { section: 'dashboard' } }
      }
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundPage }
  ],
  scrollBehavior: () => ({ top: 0 })
})

router.afterEach((to) => {
  document.title = to.meta.title ? `SimBill — ${to.meta.title}` : 'SimBill'
})

export default router
